import { render, staticRenderFns } from "./settings-organization-edit-tag.vue?vue&type=template&id=129580d8&scoped=true&"
import script from "./settings-organization-edit-tag.vue?vue&type=script&lang=js&"
export * from "./settings-organization-edit-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129580d8",
  null
  
)

export default component.exports